export default __webpack_public_path__ + "images/0f73c8976b17bededcb31c5bfa4bbdc1-republican_party.jpg";